<mat-toolbar color="accent">Cost Forecast</mat-toolbar>

<mat-dialog-content class="!text-black">
  <div class="flex flex-col gap-4">
    <p class="text-sm opacity-70">
      Select a date range to forecast upcoming campaign costs. Only pending
      steps with a forecast date within the selected range will be included.
    </p>

    <pt-date-range-form
      [range]="defaultRange"
      [useRangePicker]="true"
      [predefinedDateActions]="false"
      (changed)="runForecast($event)"
    />

    @if (loading()) {
      <div class="flex items-center justify-center py-8">
        <mat-spinner diameter="32" />
      </div>
    }

    @if (forecast(); as forecastResult) {
      <div class="flex flex-col gap-4">
        <div class="flex flex-row flex-wrap gap-8">
          <pr-statistic label="Active Entries">
            {{ forecastResult.activeEntries }}
          </pr-statistic>
          <pr-statistic label="Pending Steps">
            {{ forecastResult.pendingSteps }}
          </pr-statistic>
          <pr-statistic label="Estimated Segments">
            {{ forecastResult.estimatedSegments }}
          </pr-statistic>
          <pr-statistic label="Estimated Cost">
            {{ forecastResult.estimatedCost | currency }}
          </pr-statistic>
        </div>

        @if (forecastResult.costBreakdown.length) {
          <h3 class="!mb-0 text-sm font-semibold">Cost Breakdown by Step</h3>
          <table class="w-full text-sm">
            <thead>
              <tr class="border-b text-left opacity-70">
                <th class="py-1">Step</th>
                <th class="py-1">Entries</th>
                <th class="py-1">Segments</th>
                <th class="py-1 text-right">Cost</th>
              </tr>
            </thead>
            <tbody>
              @for (
                step of forecastResult.costBreakdown;
                track step.stepRef.path
              ) {
                <tr class="border-b">
                  <td class="py-1">{{ step.stepName }}</td>
                  <td class="py-1">{{ step.entriesAffected }}</td>
                  <td class="py-1">{{ step.estimatedSegments }}</td>
                  <td class="py-1 text-right">
                    {{ step.estimatedCost | currency }}
                  </td>
                </tr>
              }
            </tbody>
          </table>
        }

        @if (!forecastResult.costBreakdown.length) {
          <p class="py-4 text-center text-sm opacity-50">
            No pending steps found in the selected date range.
          </p>
        }
      </div>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-stroked-button (click)="close()">Close</button>
</mat-dialog-actions>
